/**
 * CircuitBreakerBadge — Circuit breaker state badge
 * Used across: MCP Servers, Health Monitor, Detail
 */

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { CircuitBreakerState } from '@/lib/mock-connections-data';

export const CB_BADGE_STYLES: Record<CircuitBreakerState, string> = {
  closed: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  half_open: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  open: 'bg-red-500/10 text-red-600 dark:text-red-400',
};

interface CircuitBreakerBadgeProps {
  state: CircuitBreakerState;
  failures?: number;
  threshold?: number;
  className?: string;
}

export function CircuitBreakerBadge({ state, failures, threshold, className }: CircuitBreakerBadgeProps) {
  return (
    <Badge variant="outline" className={cn('text-[9px]', CB_BADGE_STYLES[state], className)}>
      CB: {state.replace('_', ' ')}
      {failures != null && threshold != null && failures > 0 && ` (${failures}/${threshold})`}
    </Badge>
  );
}
